/* THRILA racewear sizing: isolated from product option/form state. */
(() => {
  'use strict';
  const dialog = document.getElementById('thrila-racewear-sizing');
  if (!dialog || dialog.dataset.trsReady || typeof dialog.showModal !== 'function') return;
  dialog.dataset.trsReady = 'true';

  const productSelector = '#MainContent [data-section-type="product"][data-modal="false"], #MainContent .tcd[data-product-id]';
  const triggerSelector = '.tpo_open-modal-button, a[href]';
  const easifyKinds = new Map([
    ['Size Guide - Jersey', 'jersey'],
    ['Size Guide - Motocross Pant', 'motocross'],
    ['Size Guide - BMX & MTB Pant', 'bmx']
  ]);
  const hashKinds = new Map([
    ['#race-jersey', 'jersey'],
    ['#motocross-pants', 'motocross'],
    ['#bmx-mtb-pants', 'bmx']
  ]);
  const titles = {
    jersey: 'Unisex jersey size guide',
    motocross: 'Motocross pant size guide',
    bmx: 'BMX & MTB pant size guide'
  };
  const panels = {
    jersey: dialog.querySelector('#thrila-racewear-jersey'),
    motocross: dialog.querySelector('#thrila-racewear-motocross'),
    bmx: dialog.querySelector('#thrila-racewear-bmx')
  };
  const title = dialog.querySelector('#thrila-racewear-sizing-title');
  const eyebrow = dialog.querySelector('[data-trs-eyebrow]');
  const closeButton = dialog.querySelector('[data-trs-close]');
  const switchButton = dialog.querySelector('[data-trs-switch]');
  let sourceRoot = null;
  let opener = null;
  let oldOverflow = null;
  let lastPant = null;

  function rootFor(element) {
    return element.closest(productSelector) || (document.querySelector('[data-tsp-global-labels]') ? document.querySelector(productSelector) : null);
  }

  function kindFor(element) {
    if (!(element instanceof Element)) return null;
    if (element.matches('.tpo_open-modal-button')) {
      return easifyKinds.get(element.textContent.replace(/\s+/g, ' ').trim()) || null;
    }
    if (element.matches('a[href]')) {
      try {
        const url = new URL(element.getAttribute('href'), window.location.href);
        if (url.origin === window.location.origin && /\/pages\/size-guide\/?$/.test(url.pathname)) {
          if (hashKinds.has(url.hash)) return hashKinds.get(url.hash);
          if (!url.hash || element.matches('.thrila-product-sizing__main')) {
            const marker = element.closest('[data-chart-ids]') || rootFor(element)?.querySelector('.thrila-product-sizing[data-chart-ids]');
            const ids = (marker?.dataset.chartIds || '').split('|');
            return ids.map(id => hashKinds.get('#' + id)).find(Boolean) || null;
          }
        }
      } catch (_) { /* Leave malformed/unrelated links untouched. */ }
    }
    return null;
  }

  function availableKinds(root) {
    const available = new Set();
    if (!root) return available;
    root.querySelectorAll(triggerSelector).forEach(element => {
      const kind = kindFor(element);
      if (kind) available.add(kind);
    });
    return available;
  }

  function relatedPant(available) {
    if (lastPant && available.has(lastPant)) return lastPant;
    const landing = sourceRoot && sourceRoot.getAttribute('data-thrila-landing');
    if (landing && available.has(landing) && landing !== 'jersey') return landing;
    if (available.has('bmx') && !available.has('motocross')) return 'bmx';
    if (available.has('motocross') && !available.has('bmx')) return 'motocross';
    return null;
  }

  function setPanel(kind) {
    const available = availableKinds(sourceRoot);
    if (kind !== 'jersey') lastPant = kind;
    Object.keys(panels).forEach(key => { panels[key].hidden = key !== kind; });
    title.textContent = titles[kind];
    const pant = kind === 'jersey' ? relatedPant(available) : kind;
    const landing = sourceRoot && sourceRoot.getAttribute('data-thrila-landing');
    eyebrow.textContent = pant === 'bmx' || (!pant && landing === 'bmx')
      ? 'THRILA / BMX & MTB' : pant === 'motocross' || landing === 'motocross'
        ? 'THRILA / Motocross' : 'THRILA / Racewear';
    const next = kind === 'jersey' ? pant : available.has('jersey') ? 'jersey' : null;
    switchButton.hidden = !next;
    switchButton.dataset.trsSwitch = next || '';
    switchButton.textContent = next === 'jersey' ? 'View jersey size guide →'
      : next === 'bmx' ? 'View BMX & MTB pant size guide →' : 'View pant size guide →';
    dialog.scrollTop = 0;
  }

  function showGuide(kind, source) {
    const root = rootFor(source);
    if (!root || !panels[kind]) return false;
    if (!dialog.open) {
      sourceRoot = root;
      opener = source;
      lastPant = null;
    }
    setPanel(kind);
    if (!dialog.open) {
      try { dialog.showModal(); } catch (_) { return false; }
      oldOverflow = {
        value: document.body.style.getPropertyValue('overflow'),
        priority: document.body.style.getPropertyPriority('overflow')
      };
      document.body.style.setProperty('overflow', 'hidden');
    }
    closeButton.focus({ preventScroll: true });
    return true;
  }

  function findTrigger(target) {
    if (!(target instanceof Element)) return null;
    const trigger = target.closest(triggerSelector);
    return trigger && rootFor(trigger) && kindFor(trigger) ? trigger : null;
  }

  function activate(event) {
    if (event.type === 'click' && (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)) return;
    const trigger = findTrigger(event.target);
    if (!trigger) return;
    if (event.type === 'keydown') {
      if (!trigger.matches('.tpo_open-modal-button') || event.isComposing || event.repeat || (event.key !== 'Enter' && event.key !== ' ')) return;
    }
    if (!showGuide(kindFor(trigger), trigger)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  // Capture only audited sizing triggers before Easify opens its old image modal.
  window.addEventListener('click', activate, true);
  window.addEventListener('keydown', activate, true);
  closeButton.addEventListener('click', () => dialog.close());
  switchButton.addEventListener('click', () => {
    const kind = switchButton.dataset.trsSwitch;
    if (!kind || !availableKinds(sourceRoot).has(kind)) return;
    setPanel(kind);
    closeButton.focus({ preventScroll: true });
  });
  let pointerDownOnBackdrop = false;
  function outsideDialog(event) {
    if (event.target !== dialog) return false;
    const bounds = dialog.getBoundingClientRect();
    return event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom;
  }
  dialog.addEventListener('pointerdown', event => { pointerDownOnBackdrop = outsideDialog(event); });
  dialog.addEventListener('click', event => {
    if (pointerDownOnBackdrop && outsideDialog(event)) dialog.close();
    pointerDownOnBackdrop = false;
  });
  // Native dialog supplies Escape dismissal and modal focus containment.
  dialog.addEventListener('close', () => {
    if (oldOverflow && document.body.style.getPropertyValue('overflow') === 'hidden') {
      if (oldOverflow.value) document.body.style.setProperty('overflow', oldOverflow.value, oldOverflow.priority);
      else document.body.style.removeProperty('overflow');
    }
    oldOverflow = null;
    if (opener && opener.isConnected) opener.focus({ preventScroll: true });
    sourceRoot = null;
    opener = null;
  });

  function enhanceTriggers() {
    document.querySelectorAll(productSelector).forEach(root => {
      root.querySelectorAll(triggerSelector).forEach(trigger => {
        if (!kindFor(trigger)) return;
        if (trigger.matches('.tpo_open-modal-button')) {
          if (!trigger.hasAttribute('role')) trigger.setAttribute('role', 'button');
          if (!trigger.hasAttribute('tabindex')) trigger.setAttribute('tabindex', '0');
        }
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.setAttribute('aria-controls', dialog.id);
      });
    });
  }
  let scanPending = false;
  function scheduleEnhancement() {
    if (scanPending) return;
    scanPending = true;
    requestAnimationFrame(() => { scanPending = false; enhanceTriggers(); });
  }
  enhanceTriggers();
  const main = document.getElementById('MainContent');
  if (main) new MutationObserver(scheduleEnhancement).observe(main, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', scheduleEnhancement);
})();
